module.exports = __webpack_public_path__ + "static/media/back.f9a66be9.webp";